import { MOCK_TYPE } from '../FetchAdapter';
import {
    AEM_CONTENT,
    ENTITLEMENTS_ALL_PERMIT,
    TOKENS_DATA,
    MEMBER_DATA,
    MEMBER_SUPPLEMENTAL_DATA,
} from '../../Components/Mocks/MockData';

/*
Bob Basic

Bob Basic is a basic member with a single dependent.
*/

const BFF_BASE_URL = window.__ENV__.BFF_URL;
const mockMap = {};
const OK = 200;

mockMap[`${BFF_BASE_URL}/transfer/v1/in`] = {
    type: MOCK_TYPE.REST,
    operations: {
        POST: {
            response: {
                status: OK,
                body: {
                    tokens: TOKENS_DATA.tokens,
                },
            },
        },
    },
};

mockMap[`${BFF_BASE_URL}/aem/v2/content`] = {
    type: MOCK_TYPE.REST,
    operations: {
        GET: {
            response: {
                status: OK,
                body: AEM_CONTENT.data,
            },
        },
    },
};

mockMap[`${BFF_BASE_URL}/log/v3/send`] = {
    type: MOCK_TYPE.REST,
    operations: {
        POST: {
            response: {
                status: OK,
                body: {},
            },
        },
    },
};

mockMap[`${BFF_BASE_URL}/api/v2`] = {
    type: MOCK_TYPE.GRAPHQL,
    operations: {
        EntitlementsQuery: {
            response: {
                status: OK,
                body: {
                    data: ENTITLEMENTS_ALL_PERMIT,
                },
            },
        },
        GetMemberQuery: {
            response: {
                status: OK,
                body: {
                    data: {
                        ...MEMBER_DATA,
                        member: {
                            ...MEMBER_DATA.member,
                            firstName: 'Dave',
                            lastName: 'Dataless',
                            postalAddress: null,
                            emailAddress: null,
                            bankAccount: null,
                        },
                    },
                },
            },
        },
        GetMemberSupplementalQuery: {
            response: {
                status: OK,
                body: {
                    data: MEMBER_SUPPLEMENTAL_DATA,
                },
            },
        },
        GetMemberBenefitsQuery: {
            response: {
                status: OK,
                body: {
                    data: {
                        member: {
                            benefits: [
                                {
                                    memberBenefitId: '12345',
                                    name: 'Health',
                                    cobRequired: true,
                                    hideCOBBenefit: true,
                                    status: 'ACTIVE',
                                    coverageType: 'COUPLE',
                                    code: 'EHC',
                                    cob: {
                                        hasOtherInsurer: true,
                                        otherInsurerName: 'OTHER',
                                    },
                                },
                                {
                                    memberBenefitId: '12346',
                                    name: 'Dental',
                                    cobRequired: true,
                                    hideCOBBenefit: false,
                                    status: 'ACTIVE',
                                    coverageType: 'COUPLE',
                                    code: 'DEN',
                                    cob: {
                                        hasOtherInsurer: true,
                                        otherInsurerName: 'OTHER',
                                    },
                                },
                            ],
                        },
                    },
                },
            },
        },
        GetFamilyQuery: {
            response: {
                status: OK,
                body: {
                    data: {
                        member: {
                            familyMembers: [
                                {
                                    personId: '1',
                                    familyMemberType: 'CHILD',
                                    status: 'TERMINATED',
                                    isStudentStatusExtendable: true,
                                    inSchool: true,
                                    firstName: 'Billy',
                                    lastName: 'Classic',
                                    birthDate: '2005-01-01',
                                    benefits: [
                                        {
                                            memberBenefitId: '1',
                                            covered: true,
                                            benefitName: 'Health',
                                            code: 'EHC',
                                            cob: {
                                                hasOtherInsurer: true,
                                                otherInsurerName: 'OTHER',
                                            },
                                            eligibleForCoverage: true,
                                        },
                                        {
                                            memberBenefitId: '2',
                                            covered: false,
                                            benefitName: 'Dental',
                                            cob: {
                                                hasOtherInsurer: true,
                                                otherInsurerName: 'OTHER',
                                            },
                                        },
                                    ],
                                },
                            ],
                            allowedDependentActions: {
                                addSpouse: true,
                                updateSpouse: true,
                                addChild: true,
                                updateChild: true,
                                extendStudent: true,
                            },
                        },
                    },
                },
            },
        },
        BankQuery: {
            response: {
                status: OK,
                body: {
                    data: { bank: { bankName: 'New Bank of Canada' } },
                },
            },
        },
        CreateMemberBankAccountMutation: {
            response: {
                status: OK,
                body: {
                    data: { createMemberBankAccount: { bankAccountId: '10101' } },
                },
            },
        },
        CommitChangesMutation: {
            response: {
                status: OK,
                body: {
                    data: {},
                },
            },
        },
        RemoveApplicationState: {
            response: {
                status: OK,
                body: {
                    data: {},
                },
            },
        },
    },
};

export default mockMap;
